import { SVGProps } from 'react';

const ScanIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_126_17117)">
        <path d="M88 0H0V88H88V0Z" fill="#1C6BEA" />
        <path
          d="M74.7 30.1992H13.3V44.1992H74.7V30.1992Z"
          fill="url(#paint0_linear_126_17117)"
        />
        <path
          d="M15.3 31.8V19.5C15.3 17.2909 17.0909 15.5 19.3 15.5H31.6"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M56.4001 15.5H68.7001C70.9093 15.5 72.7001 17.2909 72.7001 19.5V31.8"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M72.7001 56.6992V68.9992C72.7001 71.2084 70.9093 72.9992 68.7001 72.9992H56.4001"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.6 72.9992H19.3001C17.0909 72.9992 15.3 71.2084 15.3 68.9992V56.6992"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.1001 44.3008H77.9001"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_126_17117"
          x1="45.4993"
          y1="44"
          x2="45.4993"
          y2="31"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.5" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_126_17117">
          <rect width="88" height="88" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ScanIcon;
